import { CardRequest } from '../pages/CardRequest'

export const ROUTES = [
  {
    path: '/',
    component: CardRequest
  }
]
